//This user data service will limit the amount of repetitive calls we make to the user collection (for viewing others profiles etc.). 
import firebase from '@/fb'; 
import Chat from './../components/Chat/chat.js';
import moment from 'moment';
import UserDataService from './userDataService.js';
import fbAdmin from 'firebase';

export default class ChatDataService {

    async sendNewMessage(message, chatId){
        return new Promise(function(resolve, reject){
            var existingChat = new Chat();

            var rules = "Have not implemented validation yet"

            var valid = existingChat.validateMessage(rules, message);

            if (valid){
                //Do the ArrayUnion method here --> This should also reset the 'read' array
                const updateObject = {messages: fbAdmin.firestore.FieldValue.arrayUnion(message), read: [message.uid]};

                var updateReference = firebase.db.collection('chats').doc(chatId);
                updateReference.update(updateObject).then(() => {
                    resolve("Message successfully sent!");
                })
                .catch(error => {
                    reject("Error sending message: " + error);
                });
            } else {
                reject("Message was invalid: " + valid.error);
            }
        })
    }

    async createNewChat(chatName, chatType, userIds, orgId){
        return new Promise(function(resolve, reject){
            if (chatName === "" || chatName === null){
                //If the chat name has not been defined, we can determine it ourselves based on the date/users?
                chatName = "newChat"
            }

            //If this new chat that is created is a private one, construct the combination userId string
            var newChat = new Chat(chatName, chatType, null, 0, moment(new Date()).format('MM-DD-YYYY hh:mm A'), userIds, orgId, []);
            if (chatType === "Private"){
                newChat.users = [userIds[0]+userIds[1], userIds];
            }

            
    
            if (newChat){
                var addReference = firebase.db.collection('chats').add(JSON.parse(JSON.stringify(newChat)));

                addReference
                .then(async function(chatRef) {  
                    //Create a userDataService and the arrayUnion object to update the users info
                    const userDataService = new UserDataService();
                    const updateObject = {chats: fbAdmin.firestore.FieldValue.arrayUnion(chatRef.id)};

                    //Once we have created this chat, we need to loop around the Users involved and append a chat to their User objects chat array
                    //For better performance use Promise.all to execute them in parallel
                    var responseArray = await Promise.all(userIds.map(function(userId) {
                        return userDataService.updateUserById(userId, updateObject);
                    }));
                    resolve(responseArray);
                })
                .catch(function (error){
                    //Chat failed to add
                    reject("Failed to create new chat: " + error);
                })
            }                  
            
        })        
    }

    //This is only really for the orgId ones
    async joinExistingChat(userId, chatId){
        return new Promise(function(resolve, reject){
            const userDataService = new UserDataService();
            const updateObject = {users: fbAdmin.firestore.FieldValue.arrayUnion(userId)};

            var updateReference = firebase.db.collection('chats').doc(chatId).update(updateObject);
            updateReference.then(() => {
                const userUpdateObject = {chats: fbAdmin.firestore.FieldValue.arrayUnion(chatId)}
                
                //Then update the users 'chat array'
                userDataService.updateUserById(userId, userUpdateObject)
                .then(()=> {
                    //Construct the message object
                    const newMessage = {
                        uid: userId,
                        content: "A new user joined the chat!",
                        date: moment().format('MM-DD-YYYY hh:mm A')
                    }
                    //Send a new message notifying the users that someone has joined the chat
                    this.sendNewMessage(newMessage, chatId)
                    .then(() => {
                        resolve("Successfully joined chat!");
                    })
                })
                .catch((error) => {
                    reject("Error updating the users chats: " + error);
                })
            })
            .catch((error) => {
                reject("Error joining the chat: " + error);
            })
        });
    }

    async getExistingChat(userIds, type, orgId){
        return new Promise(function(resolve, reject){
            //Method to get an existing chat --> Allowing initial chat ID to be propped in
            var chatReference;
            if (type === "Private"){
                //For private chats we combine the userIds into a single string, we could have combined it either way though --> So we have to check both
                const userIdCombos = [userIds[0]+userIds[1], userIds[1]+userIds[0]];
                chatReference = firebase.db.collection('chats').where("users", "array-contains-any", userIdCombos).limit(1);
            } else {
                //For group we just rely on the single orgId
                chatReference = firebase.db.collection('chats').where("orgId", "==", orgId).where("type", "==", "Group");
            }
            
            chatReference.get()
            .then((fullDoc) => {
                var doc = fullDoc.docs[0];
                if (doc && doc.exists) {
                    resolve({id: doc.id, data: doc.data()});
                } else {
                    reject("No chat exists");
                }
            })
            .catch((error) => {
                reject("Unable to get the chat: " + error);
            })
        });
    }

    //Method will set add the userId to the chats 'Read' array --> The chat will show a small avatar of each user that has read (and show it bold in the ChatList if it is unread)
    async readChat(userId, chatId) {
        return new Promise(function(resolve, reject){
            const updateObject = {read: fbAdmin.firestore.FieldValue.arrayUnion(userId)};

            var updateReference = firebase.db.collection('chats').doc(chatId).update(updateObject);
            updateReference.then(() => {
                resolve(userId + "has read the chat")
            })
            .catch((error) => {
                reject(error);
            });
        })
    }

    //How can we implement this? onSnapshots listen indefinetly
    // async listenToChat(chatId){
    //         firebase.db.collection('chats').doc(chatId)
    //         .onSnapshot(function(doc) {
    //             resolve(doc.data());
    //         });
    // }

    //Will we need a leaveExistingChat(){
    //}

}